import { render, staticRenderFns } from "./CashupHistoryCashups.vue?vue&type=template&id=4623f13e"
import script from "./CashupHistoryCashups.vue?vue&type=script&lang=js"
export * from "./CashupHistoryCashups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports